import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionEyebrow from "./SectionEyebrow";
import ProtectedImage from "./ProtectedImage";

export default function PageHero({
  eyebrow,
  headline,
  subheadline,
  ctaLabel = "Book a Discovery Call",
  ctaTo = "/contact",
  image,
  imageAlt,
  imageProtected = false,
}) {
  return (
    <section
      data-testid="page-hero"
      className="relative bg-[#F4F7FC] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-16 md:pb-24 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          {eyebrow && <SectionEyebrow className="mb-6">{eyebrow}</SectionEyebrow>}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1E2761] leading-[1.05] tracking-tight mb-6">
            {headline}
          </h1>
          <p className="text-base md:text-lg text-[#334155]/85 leading-relaxed max-w-2xl mb-8">
            {subheadline}
          </p>
          <Link
            to={ctaTo}
            data-testid="page-hero-cta"
            className="group inline-flex items-center gap-3 bg-[#1E2761] text-white px-7 py-3.5 font-medium tracking-wide hover:bg-[#161d4b] transition-colors"
          >
            {ctaLabel}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        {image && (
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden">
              {imageProtected ? (
                <ProtectedImage src={image} alt={imageAlt} />
              ) : (
                <img
                  src={image}
                  alt={imageAlt}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              )}
              <div className="absolute -bottom-4 -left-4 w-24 h-24 border-l-2 border-b-2 border-[#C9A84C]" />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
